const setRafTimeout = (fn, delay) => {
	const start = new Date().getTime()
	const handle = {}

	const loop = () => {
		const current = new Date().getTime()
		const delta = current - start
		delta < delay ? (handle.value = requestAnimationFrame(loop)) : fn.call()
	}

	handle.value = requestAnimationFrame(loop)
	return handle
}

const clearRafTimeout = handle => {
	if (handle) {
		cancelAnimationFrame(handle.value)
	}
}

export { setRafTimeout, clearRafTimeout }
